import axios from 'axios';
import config from '@/helpers/config';

export default $axios => {
    return {
        $axios,

        async fetch(params = '') {
            return await $axios.get(`/requests${params}`);
        },

        async createRequest(form) {
            return await $axios.post('/requests', {
                ...form,
                source: "web-app"
            });
        },

        async createRequestPublic(form, token) {
            return await axios.post(`${config.apiUrl}/requests`, {
                ...form,
                source: "web-app"
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
        },

        async fetchById(id) {
            return await $axios.get(`/requests/${id}`)
        },

        async uploadImage({
            form,
            id
        }) {
            return await $axios.post(`/requests/${id}/media`, form);
        },

        async uploadImagePublic({
            form,
            id
        }, token) {
            return await axios.post(`${config.apiUrl}/requests/${id}/media`, form, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
        },

        async update({
            form,
            id
        }) {
            return await $axios.put(`/requests/${id}`, form);
        },

        async rate({
            form,
            id
        }) {
            return await $axios.post(`/requests/${id}/rate`, form);
        },

        async makePaid(id) {
            return await $axios.post(`/requests/${id}/paid`);
        },

        async updateDescription(id, form) {
            return await $axios.put(`/requests/${id}/description`, form);
        },

        async updateDate(id, form) {
            return await $axios.put(`/requests/${id}/datetime`, form);
        },

        async updateContact(id, form) {
            return await $axios.put(`/requests/${id}/contact`, form);
        },

        async fetchFiles(id) {
            return await $axios.get(`/files?entity_id=${id}`);
        },

        async addFiles(form) {
            return await $axios.post('/files', form);
        },

        async addFilesPublic(form, token) {
            return await axios.post(`${config.apiUrl}/files`, form, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
        }
    }
};